export default __webpack_public_path__ + "static/media/7.375ccb94.png";